import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { permisopagina } from 'src/app/models/permisopagina';
import { usuario } from 'src/app/models/usuario';
import { ApiauthService } from 'src/app/services/apiauth.service';
import { PermissionService } from 'src/app/services/permission.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @Output() toggleSideBarForMe: EventEmitter<any> = new EventEmitter();
  public imgUrl = '';
  usuario: usuario;
  public permisos: permisopagina[] = [];
  constructor(public apiauth: ApiauthService, public router: Router,
    public apiAuth: ApiauthService,
    public permisoService: PermissionService) {
    this.usuario = this.apiauth.usuarioData;

    this.imgUrl =
      'url(data:image/png;base64,' + this.usuario.photoProfileSmall + ')';
    if (this.usuario.photoProfileSmall.startsWith('./assets')) {
      this.imgUrl = '';
    }
  }

  ngOnInit(): void {
    // this.imgUrl = 'data:image/png;base64,' + this.apiauth.getUser().photoProfileSmall;
    this.permisoService.loadPermissions().subscribe((paginas) => {
      console.log('las paginas son: ', paginas);
      this.permisos = paginas;
    });
  
  }

  toggleSideBar() {
    this.toggleSideBarForMe.emit();
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 300);
  }

  signout() {
    this.apiauth.logout();
    this.router.navigate(['/']);
  }

  hasPermision(url: string) {
    return this.permisos.filter((x) => x.url == url).length >= 1;
  }
}
